/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var config = {
  name: 'useIAMTagsAuthz',
  type: 'retrieve',
  uri: '/iam/api/v1/accounts/{{0}}/authz_tags',
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    csrfToken: typeof window !== 'undefined' ? window.csrfToken : '',
    // Deprecated: will be removed after transition to IBM-CSRF-Token is complete
    'IBM-CSRF-Token': typeof window !== 'undefined' ? window.csrfToken : '',
    'Origin-Type': 'IBM Cloud PAL (useIAMTagsAuthz)'
  },
  documentation: {
    model: {
      isCreateAccessTagEnabled: {
        type: 'Boolean',
        description: 'Flag indicating if the user has permission to create access tags'
      },
      isAttachAccessTagEnabled: {
        type: 'Boolean',
        description: 'Flag indicating if the user has permission to attach access tags to a specified resource'
      },
      isDetachAccessTagEnabled: {
        type: 'Boolean',
        description: 'Flag indicating if the user has permission to detach access tags from a specified resource'
      },
      isAttachUserTagEnabled: {
        type: 'Boolean',
        description: 'Flag indicating if the user has permission to attach user tags to a specified resource'
      },
      isDetachUserTagEnabled: {
        type: 'Boolean',
        description: 'Flag indicating if the user has permission to detach user tags from a specified resource'
      }
    },
    params: 'This API takes no params'
  },
  mock: {
    // A mock response for the API. This will be returned if option.mock is set to true. Should match the model in the documentation
    isCreateAccessTagEnabled: true,
    isAttachAccessTagEnabled: true,
    isDetachAccessTagEnabled: true,
    isAttachUserTagEnabled: true,
    isDetachUserTagEnabled: true
  }
};
var useIAMTagsAuthzConfig = config;

export { useIAMTagsAuthzConfig as default };
